import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { brandPrimary, error, mention, titles } from '../../../web/styles/colors';

export const styles = StyleSheet.create({
	container: {
		padding: 8,
		width: 600,
		boxSizing: 'border-box',
	},
	header: {
		color: titles,
		fontSize: '1.125rem',
		margin: '0 0 24px 0',
	},
	content: {
		overflow: 'auto',
		maxHeight: 750,
	},
	infoFieldLabel: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginBottom: THEME.spacing.xs,
	},
	loadingContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: THEME.spacing.xxl,
	},
	notConfiguredText: {
		fontStyle: 'italic',
		fontSize: THEME.typography.fontSizes.sm,
		opacity: 0.6,
		marginBottom: THEME.spacing.lg,
		marginTop: THEME.spacing.sm,
	},
	customContentWebsiteUrl: {
		marginBottom: THEME.spacing.xl,
	},
	buttonContainer: {
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.md,
	},
	editFormGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(2, 1fr)',
		gap: THEME.spacing.md,
		marginBottom: THEME.spacing.md,
	},
	fieldContainer: {
		marginBottom: THEME.spacing.md,
	},
	characterCount: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
		textAlign: 'right',
	},
	characterCountError: {
		color: error,
		fontWeight: 'bold',
	},
	errorMessage: {
		color: error,
		fontSize: THEME.typography.fontSizes.xs,
		marginTop: THEME.spacing.xs,
	},
	legacyNotice: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
		fontSize: THEME.typography.fontSizes.sm,
		color: brandPrimary,
		background: mention,
		borderRadius: 6,
		padding: THEME.spacing.md,
		margin: `${THEME.spacing.sm}px 0`,
	},
	legacyNoticeIcon: {
		flexShrink: 0,
		marginTop: 2,
	},
});
